import { CdkMenuModule } from "@angular/cdk/menu";
import { ClipboardModule } from "ngx-clipboard";
import { DatePipe } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, inject, NgModule, provideAppInitializer } from "@angular/core";
import { AppModeInitService } from "./_services/app-mode-init.service";
import { FormsModule } from "@angular/forms";
import { MatPaginatorModule } from "@angular/material/paginator";
import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { environment } from "../environments/environment";
import { ApiError } from "./_errors/api-error";
import { DataSyncAlertDialogComponent } from "./_offline/component/dialog/data-sync-alert-dialog/data-sync-alert-dialog.component";
import { FileAlertDialogComponent } from "./_offline/component/dialog/file-alert-dialog/file-alert-dialog.component";
import { IplexDeviceContentsSelectDialogComponent } from "./_offline/component/dialog/iplex-device-contents-select-dialog/iplex-device-contents-select-dialog.component";
import { IplexDeviceListDialogComponent } from "./_offline/component/dialog/iplex-device-register-dialog/iplex-device-list-dialog.component";
import { IplexDeviceStartConnectDialogComponent } from "./_offline/component/dialog/iplex-device-start-connect-dialog/iplex-device-start-connect-dialog.component";
import { IplexDeviceWifiSettingsDialogComponent } from "./_offline/component/dialog/iplex-device-wifi-settings-dialog/iplex-device-wifi-settings-dialog.component";
import { ProgressDialogComponent } from "./_offline/component/dialog/progress-dialog/progress-dialog.component";
import { SelectAppLaunchTypeConfirmDialogComponent } from "./_offline/component/dialog/select-app-launch-type-confirm-dialog/select-app-launch-type-confirm-dialog.component";
import { SelectLocalFolderPathDialogComponent } from "./_offline/component/dialog/select-local-folder-path-dialog/select-local-folder-path-dialog.component";
import { IplexDeviceConnectModeOverlayComponent } from "./_offline/component/iplex-device-connect-mode-overlay/iplex-device-connect-mode-overlay.component";
import { NetworkOverlayComponent } from "./_offline/component/network-overlay/network-overlay.component";
import { OfflineReportTemplateComponent } from "./_offline/component/offline-report-template/offline-report-template.component";
import { ReportColumnImageComponent } from "./_offline/component/report-preview/report-elements/report-column-image/report-column-image.component";
import { ReportColumnComponent } from "./_offline/component/report-preview/report-elements/report-column/report-column.component";
import { ReportCustomElementOfflineComponent } from "./_offline/component/report-preview/report-elements/report-custom-element/report-custom-element.component";
import { ReportDataPlateOfflineComponent } from "./_offline/component/report-preview/report-elements/report-dataplate/report-dataplate.component";
import { ReportDropDownListOfflineComponent } from "./_offline/component/report-preview/report-elements/report-dropdown-list/report-dropdown-list.component";
import { ReportImageOfflineComponent } from "./_offline/component/report-preview/report-elements/report-image/report-image.component";
import { ReportIsoOfflineComponent } from "./_offline/component/report-preview/report-elements/report-iso/report-iso.component";
import { ReportLineOfflineComponent } from "./_offline/component/report-preview/report-elements/report-line/report-line.component";
import { ReportMeasurementPointOfflineComponent } from "./_offline/component/report-preview/report-elements/report-measurement-points/report-measurement-points.component";
import { ReportPictureOfflineComponent } from "./_offline/component/report-preview/report-elements/report-picture/report-picture.component";
import { ReportRectangleOfflineComponent } from "./_offline/component/report-preview/report-elements/report-rectangle/report-rectangle.component";
import { ReportSectionOfflineComponent } from "./_offline/component/report-preview/report-elements/report-section/report-section.component";
import { ReportSignatureOfflineComponent } from "./_offline/component/report-preview/report-elements/report-signature/report-signature.component";
import { ReportTableOfflineComponent } from "./_offline/component/report-preview/report-elements/report-table/report-table.component";
import { ReportTextOfflineComponent } from "./_offline/component/report-preview/report-elements/report-text/report-text.component";
import { VisualEventsOfflineComponent } from "./_offline/component/report-preview/report-elements/visual-events/visual-events.component";
import { ReportPageOfflineComponent } from "./_offline/component/report-preview/report-page/report-page.component";
import { ReportPreviewOfflineComponent } from "./_offline/component/report-preview/report-preview.component";
import { UtilsService } from "./_services/_utils.service";
import { AnnotationImageService } from "./_services/http-api/annotation-image.service";
import { EmbeddedReportService } from "./_services/http-api/embedded-report.service";
import { InspectionImageService } from "./_services/http-api/inspection-image.service";
import { InspectionReportService } from "./_services/http-api/inspection-report.service";
import { InspectionService } from "./_services/http-api/inspection.service";
import { LogoImageService } from "./_services/http-api/logo-image.service";
import { MarkService } from "./_services/http-api/mark.service";
import { MeUserService } from "./_services/http-api/me-user.service";
import { ReportTemplateService } from "./_services/http-api/report-template.service";
import { StructureService } from "./_services/http-api/structure.service";
import { SubjectModelService } from "./_services/http-api/subject-model.service";
import { SubjectService } from "./_services/http-api/subject.service";
import { TagsService } from "./_services/http-api/tags.service";
import { TenantUserService } from "./_services/http-api/tenant-user.service";
import { TitleService } from "./_services/http-api/title.service";
import { ReportTemplateDesignService } from "./_services/report-template-design.service";
import { SharedLockService } from "./_services/shared-lock/shared-lock.service";
import { StorageService } from "./_services/storage.service";
import { TenantDataService } from "./_services/tenant-data.service";
import { UsersStateService } from "./_services/user-state/users-state.service";
import { AuthVerifiedResolver } from "./_shared/resolver/auth-verified.resolver";
import { EmbeddedReportComponent } from "./analytics/analytics-powerbi-report/analytics-powerbi-report";
import { AppAboutComponent } from "./app-about/app-about.component";
import { AppRoutingModule } from "./app-routing.module";
import AppComponent from "./app.component";
import { CommonFolderInUseDialogComponent } from "./common-dialog/common-folder-in-use-dialog/common-folder-in-use-dialog.component";
import { CommonImagesShareDialogComponent } from "./common-dialog/common-images-share-dialog/common-images-share-dialog.component";
import { FileManagerComponent } from "./common-dialog/file-manager/file-manager.component";
import { CommonImportConfirmDialogComponent } from "./common-dialog/common-import-confirm-dialog/common-import-confirm-dialog.component";
import { CommonShareDialogComponent } from "./common-dialog/common-share-dialog/common-share-dialog.component";
import { CommonTerminateConfirmDialogComponent } from "./common-dialog/common-terminate-confirm-dialog/common-terminate-confirm-dialog.component";
import { AddTextComponent } from "./inspection-data-management/image-edit-dialog/add-text/add-text.component";
import { ImageAnnotationEditComponent } from "./inspection-data-management/image-edit-dialog/image-annotation-edit/image-annotation-edit.component";
import { ImageDataEditComponent } from "./inspection-data-management/image-edit-dialog/image-data-edit/image-data-edit.component";
import { ImageEditDialogComponent } from "./inspection-data-management/image-edit-dialog/image-edit-dialog.component";
import { ImageMeasurementEditComponent } from "./inspection-data-management/image-edit-dialog/image-measurement-edit/image-measurement-edit.component";
import { SelectMeasurementModeDialogComponent } from "./inspection-data-management/image-edit-dialog/image-measurement-edit/select-measurement-mode-dialog/select-measurement-mode-dialog.component";
import { ImagePropertyEditComponent } from "./inspection-data-management/image-edit-dialog/image-property-edit/image-property-edit.component";
import { InspectionImageEditErrorDialogComponent } from "./inspection-data-management/image-edit-dialog/inspection-image-edit-error-dialog/inspection-image-edit-error-dialog.component";
import { VideoDataEditComponent } from "./inspection-data-management/image-edit-dialog/video-data-edit/video-data-edit.component";
import { InspectionDataManagementComponent } from "./inspection-data-management/inspection-data-management.component";
import {
  InspectionReportAddDialogComponent,
  InspectionReportConfirmationDialogComponent
} from "./inspection-data-management/inspection-report-add-dialog/inspection-report-add-dialog.component";
import { MultipleImagesEditDialogComponent } from "./inspection-data-management/multiple-images-edit-dialog/multiple-images-edit-dialog.component";
import { InspectionListComponent } from "./inspection-list/inspection-list.component";
import { InspectionReportListItemComponent } from "./inspection-report-list/components/inspection-report-list-item/inspection-report-list-item.component";
import { InspectionReportListComponent } from "./inspection-report-list/inspection-report-list.component";
import { ReportCompleteConfirmDialogComponent } from "./inspection-report/inspection-report-complete-confirm-dialog.component";
import { ReportPropertiesDialogComponent } from "./inspection-report/inspection-report-edit-properties-dialog.component";
import { ReportCopyConfirmDialogComponent } from "./inspection-report/inspection-report-edit-text-copy-confirm-dialog.component";
import { ReportEditableTextsEditDialogComponent } from "./inspection-report/inspection-report-edit-text-dialog.component";
import { ReportEditableTextImportConfirmDialogComponent } from "./inspection-report/inspection-report-edit-text-import-confirm-dialog.component";
import { EditableTextsValidationDialogComponent } from "./inspection-report/inspection-report-edit-text-validation-dialog.component";
import { InspectionReportComponent } from "./inspection-report/inspection-report.component";
import { ReEditConfirmDialogComponent } from "./inspection-report/re-edit-confirm-dialog/re-edit-confirm-dialog.component";
import { ReuseConfirmDialogComponent } from "./inspection-report/reuse-confirm-dialog/reuse-confirm-dialog.component";
import { DeviceConnectDialogComponent } from "./inspection/dialogs/device-connect-dialog/device-connect-dialog.component";
import { InspectionReportHistoryComponent } from "./inspection/inspection-side-contents/inspection-report-tab/inspection-report-history/inspection-report-history.component";
import { InspectionReportTabComponent } from "./inspection/inspection-side-contents/inspection-report-tab/inspection-report-tab.component";
import { InspectionReportVersionComponent } from "./inspection/inspection-side-contents/inspection-report-tab/inspection-report-version/inspection-report-version.component";
import { InspectionSideContentsComponent } from "./inspection/inspection-side-contents/inspection-side-contents.component";
import { LocationFolderTabComponent } from "./inspection/inspection-side-contents/location-folder-tab/location-folder-tab.component";
import { InspectionComponent } from "./inspection/inspection.component";
import { IplexOneAppAboutComponent } from "./iplex-one-app-about/iplex-one-app-about.component";
import { LicenseAgreementDialogComponent } from "./license-agreement/license-agreement-dialog/license-agreement-dialog.component";
import { LicenseAgreementComponent } from "./license-agreement/license-agreement.component";
import { LicenseTextsComponent } from "./license-agreement/license-texts/license-texts.component";
import { StandaloneLicenseTextsComponent } from "./license-agreement/standalone-license-texts/standalone-license-texts.component";
import { PageHeaderComponent } from "./page-header/page-header.component";
import {
  SettingsMarksEditDialogComponent,
  SettingsMarkTitleComponent,
  SettingsTitlesEditDialogComponent
} from "./settings/settings-mark-title/settings-mark-title.component";
import { ReportTemplateDeleteConfirmDialogComponent } from "./settings/settings-report-template/report-template-delete-confirm-dialog/report-template-delete-confirm-dialog.component";
import {
  SettingsReportTemplateComponent,
  SettingsReportTemplateImportConfirmDialogComponent
} from "./settings/settings-report-template/settings-report-template.component";
import { LocationAbbreviationEditDialogComponent } from "./settings/settings-subject/location-abbreviation-edit-dialog/location-abbreviation-edit-dialog.component";
import {
  SettingsSubjectComponent,
  SettingsSubjectLocationEditDialogComponent,
  SettingsSubjectModelImageUploadDialogComponent
} from "./settings/settings-subject/settings-subject.component";
import { SettingsSubjectEditDialogComponent } from "./settings/settings-subject/subject-edit-dialog/settings-subject-edit-dialog.component";
import { SubjectModelEditDialogComponent } from "./settings/settings-subject/subject-model-edit-dialog/subject-model-edit-dialog.component";
import { SettingsTagsComponent, SettingsTagsEditDialogComponent } from "./settings/settings-tags/settings-tags.component";
import { SettingsComponent } from "./settings/settings.component";
import { SharedModule, translateModule } from "./shared.module";
import { ThirdPartyNoticeComponent } from "./third-party-notice/third-party-notice.component";
import { DeviceDataExportService, BrianDeviceExportService } from "./_services/device-data-export/brian-device-export.service";
import { SettingsIplexOneComponent } from "./settings/setting-iplex-one/settings-iplex-one.component";
import { MeasurementResultsComponent } from "./inspection-data-management/image-edit-dialog/image-measurement-edit/measurement-results/measurement-results.component";
import { MarkFilterComponent } from "./inspection-data-management/mark-filter/mark-filter.component";
import { PrintScreenFilterComponent } from "./inspection-data-management/print-screen-filter/print-screen-filter.component";
import { InspectionImageCardComponent } from "./inspection-data-management/inspection-image-card/inspection-image-card.component";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { UploadInspectionFilesDirective } from "./inspection-data-management/directives/upload-inspection-files.directive";
import { BlobService } from "./_services/blob.service";
import { ImagesFiltersStateService } from "./_services/filter-state.service";
import { ReportSummaryOfflineComponent } from "./_offline/component/report-preview/report-elements/report-summary/report-summary.component";
import { SwitchToOfflineConfirmationDialogComponent } from "./_offline/component/dialog/switch-to-offline-confirmation-dialog/switch-to-offline-confirmation-dialog.component";
import { PowerBIEmbedModule } from "powerbi-client-angular";
import { AuthConfig, FakeLeftbarComponent, NavigationSecondaryComponent, PlatformComponent, PlatformEnv } from "@evc/platform";
import { NavigationMenuComponent } from "./navigation-menu/navigation-menu.component";
import { CookieModule } from "ngx-cookie";
import {
  ButtonComponent,
  DeepPartial,
  InputComponent,
  ModalComponent,
  NavButtonComponent,
  OptionalAsyncPipe,
  StatusIndicatorComponent,
  SvgIconComponent,
  TooltipHoverDirective
} from "@evc/web-components";
import { ProgressSnackComponent } from "./_offline/component/dialog/progress-snack/progress-snack.component";
import { ImageMetadataCardComponent } from "./inspection-data-management/image-edit-dialog/image-metadata-card/image-metadata-card.component";
import { SpinnerComponent } from "./_shared/component/spinner/spinner.component";
import { OnPremiseSyncProgressDialogComponent } from "./on-premise-sync-progress-dialog/on-premise-sync-progress-dialog.component";
import { SummaryDialogComponent } from "./inspection-data-management/summary-comment/summary-comment-dialog.component";
import { CtaDirective } from "./shared/directives/cta/cta.directive";
import { LeftbarTopContentDirective } from "./shared/directives/leftbar-top-content.directive";
import { BookmarksDialogComponent } from "./analytics/bookmarks-dialog/bookmarks-dialog.component";
import { CheckboxComponent } from "./_shared/component/checkbox/checkbox.component";
import { GlobalErrorHandler } from "./_services/global-error-handler";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { SettingsTenantComponent } from "./settings/settings-tenant/settings-tenant.component";
import { ZoomSliderComponent } from "./_shared/component/zoom-slider/zoom-slider.component";
import {
  AssetTypesComponent,
  AssetTypeNavigationService,
  LiveAssetNavigationService,
  LiveAssetsComponent,
  HasPermissionDirective
} from "@rvi/asset-modules";
import { AssetTypePageComponent } from "./asset-type-page/asset-type-page.component";
import { ExternalSyncUploadService } from "./_services/image-upload/external-sync-upload.service";
import { LiveAssetPageComponent } from "./live-asset-page/live-asset-page.component";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import { MenuModule } from "primeng/menu";
import { TableModule } from "primeng/table";
import { TreeModule } from "primeng/tree";
import { DesktopMenuComponent } from "./_offline/component/desktop-menu/desktop-menu.component";
import { MultiSelectModule } from "primeng/multiselect";
import { ButtonModule } from "primeng/button";
import { VisolPreset } from "../sass/theme/visol-preset";
import { InspectionListFilterComponent } from "./inspection-list/inspection-list-filter/inspection-list-filter.component";
import { AuthService, getAuthProviders, provideEnv } from "@evc/platform";
import { AuthFailComponent } from "./auth-fail/auth-fail.component";
import { QRCodeSupportPageComponent } from "./qrcode-support-page/qrcode-support-page.component";
import { FileManagerService } from "./common-dialog/file-manager/file-manager.service";
import { isElectron, isLocal } from "./_shared/environment-helper";
import { MeasurementMerryComponent } from "./inspection-data-management/image-edit-dialog/measurement-merry/measurement-merry.component";
import { ToastComponent } from "./toast/toast.component";
import { MeasurementClientBase, MeasurementClientIpcService } from "@evident/ngx-media-viewer";
import { MetadataIpcService, MetadataService } from "@evident/ngx-metadata-writer";
import { CANCEL_LOGIN_URL, DESKTOP_LOGIN_URL, DEV_SERVER_URL, SERVER_URL } from "../visol-server/constants";
import { ReportMeasurementComponent } from "./_offline/component/report-preview/report-elements/report-measurement/report-measurement.component";
import { ConvertMeasure } from "./inspection-data-management/image-edit-dialog/measurement-merry/convert-measure.pipe";
import { LocaleSelectorComponent } from "./_shared/component/locale-selector/locale-selector.component";
import { ZoomControlComponent } from "./_shared/component/zoom-control/zoom-control.component";
import { SettingsConnectorComponent } from "./settings/settings-tenant/settings-connector/settings-connector.component";
import { DataCleanupService } from "./_services/data-cleanup.service";
import { DevMenuComponent } from "./navigation-menu/dev-menu/dev-menu.component";
import { SubjectLocationImageComponent } from "./inspection-data-management/subject-location-image/subject-location-image.component";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { InputTextModule } from "primeng/inputtext";
import { provideAssetModuleConfiguration } from "./asset-module.providers";
import { provideVisolFilePicker } from "./common-dialog/file-manager/visol-file-picker.providers";
import { ElectronService } from "./electron.service";
import { ConfirmDialogComponent } from "./common-dialog/confim-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { MigrationProgressModalComponent } from "./_services/asset-module/migration/migration-progress-modal/migration-progress-modal.component";

const backRedirectUrl = isElectron() ? SERVER_URL + CANCEL_LOGIN_URL : environment.VISOL_WEBSITE;

const redirectUrl = (() => {
  if (isElectron()) {
    return SERVER_URL + DESKTOP_LOGIN_URL;
  } else if (isLocal()) {
    return DEV_SERVER_URL;
  }
})();

const logoutUrl = isElectron() ? SERVER_URL : environment.VISOL_WEBSITE;

const authConfig: DeepPartial<AuthConfig> = {
  forceLicense: isElectron() ? false : environment.AUTH_FORCE_LICENSE,
  forceOrganization: isElectron() ? false : environment.AUTH_FORCE_ORGANIZATION,
  redirects: {
    back: backRedirectUrl,
    success: redirectUrl,
    loginFailedRoute: redirectUrl,
    logout: logoutUrl
  }
};

const platformEnv: PlatformEnv = environment;

if (environment.DEBUG_AUTH_FLOW) {
  console.debug("[app.module]:", JSON.stringify({ platformEnv, authConfig }, null, 2));
}

@NgModule({
  declarations: [
    AppComponent,
    InspectionListComponent,
    SettingsSubjectComponent,
    SettingsSubjectEditDialogComponent,
    SettingsReportTemplateComponent,
    SettingsReportTemplateImportConfirmDialogComponent,
    InspectionDataManagementComponent,
    InspectionReportAddDialogComponent,
    InspectionReportConfirmationDialogComponent,
    InspectionReportComponent,
    ReportPropertiesDialogComponent,
    ReportEditableTextsEditDialogComponent,
    ReportCompleteConfirmDialogComponent,
    EditableTextsValidationDialogComponent,
    InspectionReportListComponent,
    LicenseAgreementComponent,
    SettingsMarkTitleComponent,
    SettingsTagsComponent,
    ProgressDialogComponent,
    InspectionComponent,
    SettingsSubjectLocationEditDialogComponent,
    ReportCopyConfirmDialogComponent,
    InspectionImageEditErrorDialogComponent,
    SettingsMarksEditDialogComponent,
    SettingsTitlesEditDialogComponent,
    SettingsTagsEditDialogComponent,
    SettingsSubjectModelImageUploadDialogComponent,
    ReportEditableTextImportConfirmDialogComponent,
    SummaryDialogComponent,
    SettingsComponent,
    InspectionReportHistoryComponent,
    InspectionReportVersionComponent,
    ReuseConfirmDialogComponent,
    ImageEditDialogComponent,
    ImageDataEditComponent,
    ImageAnnotationEditComponent,
    ImagePropertyEditComponent,
    AddTextComponent,
    InspectionImageCardComponent,
    ReEditConfirmDialogComponent,
    ReportTemplateDeleteConfirmDialogComponent,
    LocationFolderTabComponent,
    SettingsTenantComponent,
    InspectionReportTabComponent,
    MultipleImagesEditDialogComponent,
    SubjectModelEditDialogComponent,
    CommonShareDialogComponent,
    NetworkOverlayComponent,
    InspectionReportAddDialogComponent,
    ReportPreviewOfflineComponent,
    ReportPageOfflineComponent,
    ReportTextOfflineComponent,
    ReportLineOfflineComponent,
    ReportImageOfflineComponent,
    ReportRectangleOfflineComponent,
    ReportPictureOfflineComponent,
    ReportSignatureOfflineComponent,
    ReportSummaryOfflineComponent,
    ReportTableOfflineComponent,
    ReportSectionOfflineComponent,
    ReportDataPlateOfflineComponent,
    ReportMeasurementPointOfflineComponent,
    VisualEventsOfflineComponent,
    ReportIsoOfflineComponent,
    ReportDropDownListOfflineComponent,
    ReportCustomElementOfflineComponent,
    ReportColumnComponent,
    ReportColumnImageComponent,
    ReportMeasurementComponent,
    ImageMeasurementEditComponent,
    FileAlertDialogComponent,
    InspectionSideContentsComponent,
    InspectionImageCardComponent,
    CommonImagesShareDialogComponent,
    FileManagerComponent,
    ConfirmDialogComponent,
    LocationAbbreviationEditDialogComponent,
    DataSyncAlertDialogComponent,
    ThirdPartyNoticeComponent,
    EmbeddedReportComponent,
    IplexDeviceConnectModeOverlayComponent,
    AppAboutComponent,
    LicenseTextsComponent,
    LicenseAgreementDialogComponent,
    IplexDeviceListDialogComponent,
    OfflineReportTemplateComponent,
    CommonImportConfirmDialogComponent,
    StandaloneLicenseTextsComponent,
    IplexDeviceWifiSettingsDialogComponent,
    IplexDeviceStartConnectDialogComponent,
    VideoDataEditComponent,
    DeviceConnectDialogComponent,
    IplexOneAppAboutComponent,
    CommonFolderInUseDialogComponent,
    IplexDeviceContentsSelectDialogComponent,
    SelectLocalFolderPathDialogComponent,
    CommonTerminateConfirmDialogComponent,
    SelectAppLaunchTypeConfirmDialogComponent,
    SelectMeasurementModeDialogComponent,
    QRCodeSupportPageComponent,
    InspectionReportListItemComponent,
    SettingsIplexOneComponent,
    MeasurementResultsComponent,
    MarkFilterComponent,
    PrintScreenFilterComponent,
    UploadInspectionFilesDirective,
    ProgressSnackComponent,
    ImageMetadataCardComponent,
    SwitchToOfflineConfirmationDialogComponent,
    OnPremiseSyncProgressDialogComponent,
    NavigationMenuComponent,
    SwitchToOfflineConfirmationDialogComponent,
    SpinnerComponent,
    BookmarksDialogComponent,
    AssetTypePageComponent,
    LiveAssetPageComponent,
    DesktopMenuComponent,
    InspectionListFilterComponent,
    AuthFailComponent,
    DevMenuComponent,
    SubjectLocationImageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HammerModule,
    FormsModule,
    translateModule,
    CookieModule.withOptions(),
    ClipboardModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    DragDropModule,
    PdfViewerModule,
    PageHeaderComponent,
    InfiniteScrollDirective,
    PowerBIEmbedModule,
    PlatformComponent,
    FakeLeftbarComponent,
    NavigationSecondaryComponent,
    StatusIndicatorComponent,
    ButtonComponent,
    CdkMenuModule,
    SvgIconComponent,
    CtaDirective,
    LeftbarTopContentDirective,
    ModalComponent,
    CheckboxComponent,
    InputComponent,
    NgxSliderModule,
    ZoomSliderComponent,
    NavButtonComponent,
    TooltipHoverDirective,
    AssetTypesComponent,
    LiveAssetsComponent,
    MenuModule,
    TableModule,
    TreeModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MultiSelectModule,
    ButtonModule,
    MeasurementMerryComponent,
    ToastComponent,
    ConvertMeasure,
    LocaleSelectorComponent,
    ZoomControlComponent,
    HasPermissionDirective,
    SettingsConnectorComponent,
    MigrationProgressModalComponent,
    OptionalAsyncPipe
  ],
  providers: [
    provideEnv(platformEnv),
    ...getAuthProviders(platformEnv, authConfig),
    provideAppInitializer(() => {
      const appModeInitService = inject(AppModeInitService);
      return appModeInitService.initMode();
    }),
    InspectionService,
    { provide: DeviceDataExportService, useClass: BrianDeviceExportService },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    provideAnimations(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: VisolPreset,
        options: {
          darkModeSelector: ".dark-theme"
        }
      }
    }),
    {
      provide: MeasurementClientBase,
      useClass: MeasurementClientIpcService
    },
    {
      provide: MetadataService,
      useClass: MetadataIpcService
    },
    UsersStateService,
    AssetTypeNavigationService,
    LiveAssetNavigationService,
    InspectionReportService,
    InspectionImageService,
    ExternalSyncUploadService,
    SubjectModelService,
    SubjectService,
    TenantDataService,
    BlobService,
    ImagesFiltersStateService,
    UtilsService,
    MarkService,
    TitleService,
    TagsService,
    LogoImageService,
    ReportTemplateService,
    StorageService,
    MeUserService,
    TenantUserService,
    StructureService,
    ReportTemplateDesignService,
    AuthVerifiedResolver,
    AnnotationImageService,
    EmbeddedReportService,
    SharedLockService,
    ApiError,
    AuthService,
    DatePipe,
    ElectronService,
    DataCleanupService,
    FileManagerService,
    MatDialog,
    ...provideAssetModuleConfiguration(),
    provideVisolFilePicker()
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
